import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { SeriesShowComponents } from "../react_isomorphic/series_show";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";

window.ReactComponents = Object.assign(
  {},
  GlobalComponents,
  HeaderComponents,
  SeriesShowComponents
);

window.ReactStores = Object.assign(
  {},
  GlobalStores,
  HeaderStores
);
